export default __webpack_public_path__ + "static/media/j_wdt_c_5.bafd4504.mp3";